import { Modality } from '~/domain/dicom/modality';
import { getModalityBackgroundValue } from './modalityDefaults';

/**
 * The value written where the output reaches past the source.
 *
 * The minimum of the source volume, not a modality constant: a scanner's
 * out-of-field value is frequently not -1024 HU — -2048 and -3024 are both
 * common outside the reconstruction circle — and padding with a different
 * air than the image's own leaves a visible step at the seam that reads as
 * anatomy. Taking the minimum tracks whatever this acquisition actually
 * used.
 *
 * An empty volume has no minimum to take, so the modality default stands
 * in; nothing else can be inferred from no data.
 *
 * This does NOT make the padded region equivalent to acquired air — it is
 * fabricated content, and {@link paddedFractionInBox} exists so the caller can
 * say how much of the output it is.
 */
export function sourcePaddingValue(
    pixels: Int16Array,
    modality: Modality
): number {
    if (pixels.length === 0) {
        return getModalityBackgroundValue(modality);
    }
    let min = pixels[0];
    for (let i = 1; i < pixels.length; i++) {
        if (pixels[i] < min) {
            min = pixels[i];
        }
    }
    return min;
}
